import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import FieldText from "../fields/FieldText";
import Btn from "../Btn";
import { isInvalid } from "../../utils/isInvalid";
import main from "../../assets/svg/main.svg";
import ykf from "../../assets/svg/ykf.svg";
import { Loader } from "../Loader";

export const Authorization = ({ onSubmitData, invalidAuth, loadingAuth=false }) => {

    const [data, setData] = useState({
        email: '',
        code:  '',
    });
    const [invalidData, setInvalidData] = useState({});

    const findInvalidField = (dataField) => {
        const dataInvalid = { body: {}, status: false };

        for (const key in dataField) {
            if ({}.hasOwnProperty.call(dataField, key)) {
                const val = isInvalid(key, dataField[key]);

                if (val) {
                    dataInvalid.body[key] = val;
                    dataInvalid.status = true;
                }
            }
        }

        return dataInvalid;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const invalidFields = findInvalidField(data);

        if (invalidFields.status) {
            setInvalidData(invalidFields.body);

            return null;
        }

        onSubmitData(data);
        //console.log('click btn');

    };

    const onChangeField = (e) => {
        const target = e.target;
        const newData = { ...data };
        const newDataInvalid = { ...invalidData };

        newData[target.name] = target.value;
        if (newDataInvalid[target.name]) {
            delete newDataInvalid[target.name];
        }

        setData(newData);
        setInvalidData(newDataInvalid);
    };

    return (
        <div className = 'authorization' >
            <div
                className = { `authorization__container m-width` }>

                <div className = 'authorization__left'>
                    <div className = 'authorization__wrap'>
                        <div className = 'authorization__head'>
                            <div className = 'main-logo' >
                                <img alt = 'logo' className = 'main-logo__img' src = { main } />
                            </div>
                            <div className = 'second-logo' >
                                <img alt = 'logo' className = 'second-logo__img' src = { ykf } />
                            </div>
                        </div>
                        <div className = 'authorization__info'>
                            <h1 className = 'authorization__title'>Авторизація для голосування</h1>
                            <p className = 'authorization__text' >
                                Система розроблена на замовлення Міністерства культури та інформаційної політики України
                                для проведення рейтингового інтернет-голосування з обрання відповідної частини складу
                                Наглядової ради Українського культурного фонду
                            </p>
                        </div>
                    </div>
                </div>
                <div className = 'authorization__right' >
                    <div className = 'authorization__form' >
                        <form className = 'form' onSubmit = { onSubmit }>
                            <div className = 'form__field-wrap'>

                                <FieldText
                                    code = 'email'
                                    invalid = { invalidData.email }
                                    label = 'Пошта'
                                    placeholder = 'test@test.ua'
                                    onChange = { onChangeField }
                                />
                            </div>
                            <div>
                                <FieldText
                                    code = 'code'
                                    invalid = { invalidData.code }
                                    label = 'Код'
                                    placeholder = 'f1Df4g'
                                    onChange = { onChangeField }
                                />
                            </div>
                            { loadingAuth && <div className = 'authorization__loader-wrap'><Loader colorCircle = '#ccc' /></div>}
                            {
                                !loadingAuth && invalidAuth && <div className = 'form__bad-request'>
                                    <span>Неправильно введена Пошта або Код із листа-запрошення</span>
                                </div>
                            }
                            <div className = 'authorization__submit'>
                                <Btn
                                    full
                                    theme = 'black'
                                    title = 'Взяти участь'
                                    type = 'submit'
                                    onPress = { () => {} }
                                />
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    );
};

Authorization.propTypes = {
    onSubmitData: PropTypes.func.isRequired,
    loadingAuth:  PropTypes.bool,
    invalidAuth:  PropTypes.bool,
};
